var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_14_3",
    "data-name": "Component 14 \\u2013 3",
    transform: "translate(1.5 1.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M12.5,9.737A7.829,7.829,0,0,1,9.223,9.1,5,5,0,0,1,7.053,7.277a4.914,4.914,0,0,1-.772-2.75,6.845,6.845,0,0,1,1.954-4.8A4.314,4.314,0,0,1,6.8-1.02,4.429,4.429,0,0,1,5.7-2.226,2.7,2.7,0,0,1,5.292-3.7a4.395,4.395,0,0,1,.253-1.435,5.993,5.993,0,0,1,.7-1.4A4.664,4.664,0,0,1,7.294-7.653a2.846,2.846,0,0,1,1.857-.7,3.309,3.309,0,0,1,1.544.362,10.909,10.909,0,0,1,1.761,1.23l-.41.772a13.189,13.189,0,0,0-1.29-.326,5.4,5.4,0,0,0-1-.109,5.6,5.6,0,0,0-1.519.217,7.552,7.552,0,0,0-1.568.651,3.125,3.125,0,0,0,.989,2.364,5.076,5.076,0,0,0,2.75,1.23,16.312,16.312,0,0,1,1.942-1.025,20.781,20.781,0,0,1,2.279-.856,1.325,1.325,0,0,1,.265.748,1.189,1.189,0,0,1-.145.579,1.716,1.716,0,0,1-.506.531,5.238,5.238,0,0,1-.868.482q-.531.241-1.158.482A14.5,14.5,0,0,0,9.356.524a6.472,6.472,0,0,0-1.6,1.616,4.6,4.6,0,0,0-.446.977,3.371,3.371,0,0,0-.157,1.025A3.03,3.03,0,0,0,8.524,6.794a7.186,7.186,0,0,0,4.052.941q.6,0,1.158-.024t1.085-.072q.941-.072,1.821-.217t1.8-.362l.265.82a16.771,16.771,0,0,1-3.22,1.387A10.287,10.287,0,0,1,12.5,9.737Z",
    transform: "translate(6.299 16.706)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 18.25,
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLang);
export default __webpack_public_path__ + "static/media/icon-lang.106649f3c1c682b51d206859767138fd.svg";
export { ForwardRef as ReactComponent };